import { BrandCard, Faqs, NavItemSnippet } from './shared'

export const newCarsSnippets: NavItemSnippet[] = [
  {
    heading: 'Finance offers',
    snippet: 'Explore the latest new car finance deals across all brands',
    linkText: 'View offers',
    href: '/new-cars/offers',
    ariaLabel: 'Navigate to new car finance offers page',
    trackingAction: 'New car finance offers',
  },
  {
    heading: 'cinch x Marshall',
    snippet: 'Discover why we’re partnering to sell new cars',
    linkText: 'Learn more',
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/27062254452125-What-is-the-relationship-between-cinch-and-Marshall-Motor-Group',
    ariaLabel: 'Navigate to cinch x Marshall page',
    trackingAction: 'cinch x Marshall',
  },
]

export const newCarsFAQs: Faqs[] = [
  {
    label: 'Can I buy a new car on cinch?',
    href: ' https://help.cinch.co.uk/hc/en-gb/articles/23778617731229-Can-I-buy-a-new-car-on-cinch',
  },
  {
    label: 'Can I buy a new car on finance?',
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/31094885036189-What-are-my-payment-options-when-buying-a-new-car',
  },
  {
    label: 'How do I test drive a new car?',
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/31094878159389-Can-I-test-drive-a-new-car',
  },
  {
    label: "Why we're partnering with Marshall to sell new cars?",
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/27062254452125-What-is-the-relationship-between-cinch-and-Marshall-Motor-Group',
  },
]

export const newCarBrands: BrandCard[] = [
  {
    type: 'link',
    href: '/new-cars/byd',
    image:
      'https://a.storyblok.com/f/143588/70x14/59decdd208/byd-logo-black.svg',
    alt: 'BYD brand logo',
  },
  {
    type: 'link',
    href: '/new-cars/omoda',
    image:
      'https://a.storyblok.com/f/143588/135x18/20ee9fd928/omoda-logo-black.svg',
    alt: 'OMODA brand logo',
  },
  {
    type: 'link',
    href: '/new-cars/jaecoo',
    image:
      'https://a.storyblok.com/f/143588/1696x263/8c7accb0c4/jaecoo-logo-black.svg',
    alt: 'JAECOO brand logo',
  },
  {
    type: 'link',
    href: '/new-cars/chery',
    image:
      'https://a.storyblok.com/f/143588/99x74/93c0907eab/chery-logo-black.svg',
    alt: 'Chery brand logo',
  },
  {
    type: 'link',
    label: 'More brands coming soon',
  },
]
